import { useState } from "react";
import { CgSpinner } from "react-icons/cg";
import { IoMdClose } from "react-icons/io";
import { setAppError } from "../../../../store/userSlice";
import { useDispatch } from "react-redux";
import nodeinstance from "../../../../nodeInstance";

export default function SecDepositecost({
  showPromptElement,
  setShowPromptElement,
  summaryUpdate,
  setSummaryUpdate,
  clProject,
}) {
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState();
  const token = localStorage.getItem("nodeToken");
  const dispatch = useDispatch();
  console.log("clProject......clProject", clProject);
  const hanldeClose = () => {
    setShowPromptElement(false);
  };
  const [response, setResponse] = useState();
  const submitHandler = async (e, fileData) => {
    console.log("fileData......", fileData, file);
    e.preventDefault();
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("project_id", clProject && clProject[0]?.project_id);
      if (fileData) {
        const response = await nodeinstance.put(
          `/dashboard/visaSecOnArrival/uploadSecDep`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "multipart/form-data",
            },
          }
        );
        if (response.status === 200) {
          setSummaryUpdate(!summaryUpdate);
          if (
            response.data.totalSuccess > 0 &&
            response.data.existingEmployees.length <= 0 &&
            response.data.validation_Failed.length <= 0
          ) {
            setShowPromptElement(false);
          }
          setLoading(false);
          setResponse(response);
          dispatch(
            setAppError({
              msg: "Successfully uploaded.",
              color: "success",
            })
          );
          // setSummaryUpdate(!summaryUpdate);
        }
        console.log("success to be seen here......", response);
      }
    } catch (error) {
      setLoading(false);
      dispatch(
        setAppError({
          msg: error.message,
        })
      );
    }
  };
  console.log("response.........to be seen here", response);
  const filteredEmployees = response?.data?.existingEmployees?.filter(
    (data) => {
      if (
        response.data.Invoice_Type === "Security Deposit Cost"
      ) {
        return data.security_deposit_payment_status === "RAISED";
      } else if (response.data.Invoice_Type === "Visa Cost") {
        return data.visa_cost_payment_status === "RAISED";
      }
      return false; // fallback in case neither condition matches
    }
  );

  // If the filtered list length is 0, close the popup
  if (filteredEmployees?.length === 0 && response.data.validation_Failed.length <= 0) {
    hanldeClose();
  }

  return (
    <>
      <div
        className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50 justify-center items-center ${
          showPromptElement ? "flex" : "hidden"
        }`}
      >
        {/* Check if there's any failed validation or existing employees */}
        {response?.data?.validation_Failed?.length > 0 ||
        response?.data?.existingEmployees?.length > 0 ? (
          <div className="max-w-lg w-full h-auto rounded-md bg-white/95 flex flex-col p-4 relative">
            <label className="label">
              <span className="label-text">Failed employees list</span>
            </label>

            {/* Combine both lists */}
            <ul className="list-disc pl-5">
              {response?.data?.validation_Failed?.map((data, index) => (
                <li key={index} className="mb-2">
                  {/* Employee ID in red */}
                  <span className="text-red-500">{data.employeeId}</span>
                  <span>{` validation has been failed for these employees`}</span>
                </li>
              ))}
              {filteredEmployees?.map((data, index) => (
                <li key={index} className="mb-2">
                  {/* Employee ID in red */}
                  <span className="text-red-500">{data.employee_id}</span>
                  <span>{` the amount has already been issued against this employee`}</span>
                </li>
              ))}
            </ul>

            <div className="flex justify-center">
              <button
                className="p-1 bg-blue text-white rounded-md w-32 m-2 my-4 flex gap-3 justify-center items-center text-sm"
                onClick={() => {
                  hanldeClose();
                }}
              >
                <p>CANCEL</p>
              </button>
            </div>
          </div>
        ) : (
          <div className="max-w-lg w-full h-auto rounded-md bg-white/95 flex flex-col p-4 relative">
            <form onSubmit={(e) => submitHandler(e, file)} className="w-full">
              <div className="w-full flex flex-col gap-3 my-3 p-5">
                <div className="form-control w-full">
                  <label className="label">
                    <span className="label-text">Upload File</span>
                  </label>
                  <input
                    type="file"
                    className="file-input file-input-bordered w-full"
                    onChange={(e) => setFile(e.target.files[0])}
                    required
                    accept=".xls,.xlsx"
                  />
                </div>
                <div
                  className="flex gap-3 w-full justify-center"
                  style={{ m: 2 }}
                >
                  <button
                    className="p-2 bg-blue text-white rounded-md w-full max-w-sm m-2 my-4 flex gap-3 justify-center items-center"
                    onClick={() => {
                      hanldeClose();
                    }}
                  >
                    <p>CANCEL</p>
                  </button>

                  <button
                    type="submit"
                    className="p-2 bg-red text-white rounded-md w-full max-w-sm m-2 my-4 flex gap-3 justify-center items-center"
                  >
                    <p>Submit</p>
                    {loading ? <CgSpinner className="animate-spin" /> : ""}
                  </button>
                </div>
              </div>
            </form>
          </div>
        )}
      </div>
    </>
  );
}
